import "core-js/modules/es.array.concat";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import md5 from 'md5';
import { mapActions } from 'vuex';
export default {
  meta: {
    title: '修改密码',
    auth: true,
    authorityValue: "store-router-page"
  },
  name: 'editPwd',
  data: function data() {
    var _this = this;

    var checkPass = function checkPass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== _this.formLogin.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    return {
      // 表单
      formLogin: {
        oldPassword: '',
        newPassword: '',
        checkPassword: ''
      },
      // 表单校验
      rules: {
        oldPassword: [{
          required: true,
          message: '请输入旧密码',
          trigger: 'blur'
        }],
        newPassword: [{
          required: true,
          message: '请输入新密码',
          trigger: 'blur'
        }],
        checkPassword: [{
          required: true,
          message: '请确认密码',
          trigger: 'blur'
        }, {
          validator: checkPass,
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    VUE_APP_LOGIN_SALT: function VUE_APP_LOGIN_SALT() {
      return process.env.VUE_APP_LOGIN_SALT;
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/account', ['logout'])), {}, {
    /**
     * @description 提交表单
     */
    submit: function submit() {
      var _this2 = this;

      this.$refs.loginForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
          var oldPswMD5, newPswMD5;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!valid) {
                    _context.next = 7;
                    break;
                  }

                  oldPswMD5 = md5("".concat(_this2.formLogin.oldPassword).concat(_this2.VUE_APP_LOGIN_SALT));
                  newPswMD5 = md5("".concat(_this2.formLogin.newPassword).concat(_this2.VUE_APP_LOGIN_SALT));
                  _context.next = 5;
                  return _this2.$api.updatePassword({
                    oldPassword: oldPswMD5,
                    newPassword: newPswMD5
                  });

                case 5:
                  _this2.$notify.success({
                    title: '成功',
                    message: '修改成功,重新登陆'
                  });

                  _this2.logout({
                    confirm: false
                  });

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  })
};